import { SkillForm } from "@/core/skillForms/types";
import { interviewScriptSkillStep1 } from "./step1";

export const interviewScriptSkillForm: SkillForm = {
  skillId: "create_interview_script",
  title: "Roteiro de entrevista com o cliente",
  steps: [interviewScriptSkillStep1],
};
